import { get } from "api/axiosApi";
import { env } from "utils/env";

const masterPartnerUrl = env.REACT_APP_LSNG_MASTERPARTNER_API_URL;

export function getBanks(search) {
  return get(`${masterPartnerUrl}/dictionaries/banks?search=${search}`);
}
